function initClickSortDropdownListener() {
  const dropdown = document.querySelector(".sort-dropdown");

  if (dropdown) {
    const valueSpan = dropdown.querySelector(".sort-dropdown__value");
    const iconBottom = dropdown.querySelector(".icon.bottom");
    const optionsList = dropdown.querySelector(".sort-dropdown__options");

    dropdown.addEventListener("click", (event) => {
      const { target } = event;

      if (target === valueSpan || iconBottom?.contains(target)) {
        optionsList.classList.toggle("is-open");
        valueSpan.classList.toggle("is-click");
      }
    });

    document.addEventListener("click", (event) => {
      if (!dropdown.contains(event.target)) {
        optionsList.classList.remove("is-open");
        valueSpan.classList.remove("is-click");
      }
    });
  }
}

export default initClickSortDropdownListener;
